import { setup } from "web/entrypoints/common/setup";

import "./baustein-main";
import "./css-main";
import components from "./react-main";

setup(components);
